import type { IssuedQuoteVersion, ProductionOrderSheetFields } from '@repo/api-contracts';
import type { ReactElement } from 'react';
import { cn } from '@/shared/ui';

interface PartiesTableProps {
  readonly fields: ProductionOrderSheetFields;
  readonly issuer: IssuedQuoteVersion['issuer'];
}

const CELL_CLASS = 'border border-foreground/20 px-3 py-2 text-left align-top print:border-black';

/** 발주서 수신(발주처, 직접 입력)·발신(발주사, 견적 발행자) 표 — 값이 없어도 칸은 그대로 둔다. */
export const PartiesTable = ({ fields, issuer }: PartiesTableProps): ReactElement => {
  const rows: readonly (readonly [string, string, string])[] = [
    ['업체명', fields.supplierName, issuer.companyName],
    ['사업자등록번호', '', issuer.businessRegistrationNumber],
    ['담당자·대표', fields.supplierContact, issuer.representativeName],
    ['주소', '', issuer.address],
    ['연락처', fields.supplierPhone, issuer.contact],
    ['이메일', fields.supplierEmail, ''],
  ];

  return (
    <table aria-label="수신 및 발신" className="w-full border-collapse text-sm">
      <thead>
        <tr>
          <th scope="col" className={cn(CELL_CLASS, 'w-36')}>
            구분
          </th>
          <th scope="col" className={CELL_CLASS}>
            수신 (발주처)
          </th>
          <th scope="col" className={CELL_CLASS}>
            발신 (발주사)
          </th>
        </tr>
      </thead>
      <tbody>
        {rows.map(([label, receiver, sender]) => (
          <tr key={label}>
            <th scope="row" className={cn(CELL_CLASS, 'font-medium')}>
              {label}
            </th>
            <td className={CELL_CLASS}>{receiver}</td>
            <td className={CELL_CLASS}>{sender}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};
